<template>
  <div>
    <div class="clickHouse-title">
      <div>{{ $t("RAM.ALI.ClickHouse.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:ali:clickHouse:update'
          ]"
          :loading="modal_loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:ali:clickHouse:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="clickHouse-top">
      <click-house-search ref="search"></click-house-search>
    </div>
    <table-click-house></table-click-house>
  </div>
</template>

<script>
import ClickHouseSearch from "../clickHouse/ClickHouseSearch";
import TableClickHouse from "../clickHouse/TableClickHouse";

export default {
  name: "ClickHouse",
  components: {
    ClickHouseSearch,
    TableClickHouse
  },
  data() {
    return {
      modal_loading: false,
      companyId: "",
      clusterId: ""
    };
  },
  methods: {
    update: function() {
      this.companyId = this.$refs.search.companyId;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 305
        })
        .then(res => {
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });

      // 获取子组件数据
      this.companyId = this.$refs.search.companyId;
      this.clusterId = this.$refs.search.clusterId;
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAliClickHouse({
          companyId: this.companyId,
          accountName: this.accountName,
          clusterId: this.clusterId
        })
        .then(res => {
          let fileName = "clickHouse.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t('common.exportSuccess'));
        });
    }
  }
};
</script>

<style scoped>
.clickHouse-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.clickHouse-title > div:nth-child(1) {
  float: left;
}
.clickHouse-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.clickHouse-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/clickHouse/ClickHouse.vue